import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../..//utils/constants'

export const ModalOverlay = styled.div`
  position: relative;
  background: white;
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 100%;
  max-width: 100%;
  margin: 10px auto;
  box-sizing: border-box;

  @media (max-width: ${size.laptop}) {
    margin: 10px auto;
    width: calc(100% - 20px);
  }
`

export const ModalContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`

export const FeecbackMessage = styled.p`
  margin: 0;
  padding: 0;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
      .ASSISTANT_FOREGROUND};
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
`

export const FeedbackOptions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 5px;
`

export const FeedbackOption = styled.span`
  cursor: pointer;
  font-size: 30px;
  line-height: 1;
  padding: 0;
  border: none;
  background: none;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
`

export const CloseIcon = styled.span`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 16px;
  height: 16px;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  &:before,
  &:after {
    position: absolute;
    left: 8px;
    content: ' ';
    height: 16px;
    width: 2px;
    background-color: #333;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`

export const SuccessMessage = styled.div`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
      .ASSISTANT_FOREGROUND};
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  text-align: center;
  padding: 20px 0;
`
